<template>
  <div class="value-symbiosis">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">成为易隆创服务商，从工单执行到价值共生</div>
      </div>
      <div class="module-body">
        <div class="body-left">
          <div class="title">易隆创·服务生态诚邀您价值共创！</div>
          <div class="content">
            <div class="content-item">
              <div class="item-tag">业务扩容</div>
              <div class="item-text">服务区域内商机聚合，服务半径内订单翻倍</div>
            </div>
            <div class="content-item">
              <div class="item-tag">工单提效</div>
              <div class="item-text">平台创新“工单-项目”深度绑定模块，降低前期沉没成本</div>
            </div>
            <div class="content-item">
              <div class="item-tag">资源统筹</div>
              <div class="item-text">识别服务人员产能状态，大幅提升资源利用率</div>
            </div>
            <div class="content-item">
              <div class="item-tag">价值共生</div>
              <div class="item-text">多点商机、多点收益，服务商与平台共拓增量</div>
            </div>
          </div>
        </div>
        <img class="circle" src="@/assets/img/service-provider/ValueSymbiosis/circle.png" alt="vs">
        <div class="body-right">
          <div class="title">当您的企业还在使用传统工单系统时</div>
          <div class="content">
            <div class="content-item">
              <div class="item-tag">范围受限</div>
              <div class="item-text">难以突破地域限制，只能接零单散单</div>
            </div>
            <div class="content-item">
              <div class="item-tag">响应较慢</div>
              <div class="item-text">无法快速响应用户诉求，间接导致业务流失</div>
            </div>
            <div class="content-item">
              <div class="item-tag">资源不匀</div>
              <div class="item-text">资源调度缺乏统筹，区域间工作量分布不均</div>
            </div>
            <div class="content-item">
              <div class="item-tag">成本高昂</div>
              <div class="item-text">单点商机、单点收益，企业运营成本高昂</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.value-symbiosis {
  padding: 64px 0;

  .content-center {
    .module-body {
      margin-top: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .body-left,
      .body-right {
        width: 610px;
        height: 480px;
        padding: 60px;
        background-size: 100% 100%;
        .title {
          font-weight: bold;
          font-size: 18px;
          text-align: center;
        }
        .content {
          margin-top: 16px;
          .content-item {
            height: 80px;
            padding-right: 16px;
            border-bottom: 1px dashed #F7A34D;
            display: flex;
            align-items: center;
            position: relative;
            .item-tag {
              width: 76px;
              text-align: center;
              line-height: 28px;
              border-radius: 5px;
              font-family: @font-medium;
              font-size: 14px;
            }
            .item-text {
              flex: 1;
              margin-left: 16px;
              line-height: 24px;
            }
          }
        }
      }
      .body-left {
        padding-right: 120px;
        background-image: url('@/assets/img/service-provider/ValueSymbiosis/left_background.png');
        .title {
          color: #C46D13;
        }
        .content .content-item {
          &::after {
            content: '';
            width: 24px;
            height: 24px;
            background-image: url('@/assets/img/service-provider/ValueSymbiosis/icon_good.png');
            background-size: 100%;
            position: absolute;
            right: -17px;
            top: 50%;
            transform: translateY(-50%);
          }
          .item-tag {
            color: #fff;
            background: linear-gradient(to right, #FF9B02, #FF8100);
          }
        }
      }
      .body-right {
        padding-left: 120px;
        background-image: url('@/assets/img/service-provider/ValueSymbiosis/right_background.png');
        .content .content-item {
          border-bottom-color: #F0C497;
          .item-tag {
            background-color: #eeddcd;
          }
        }
      }

      .circle {
        width: 174px;
        height: 174px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
